import { yupResolver } from '@hookform/resolvers/yup';
import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDependenciesValues } from '../../hooks/useDependenciesValues';
import { ForecastByRoomTypeReportFormModel } from '../../models';
import { FilterForm } from './FilterForm';
import { schema } from './schema';

export const FilterFormProvider: FC<{
  defaultValues: ForecastByRoomTypeReportFormModel;
  onSubmit: (data: ForecastByRoomTypeReportFormModel) => void;
}> = ({ defaultValues, onSubmit }) => {
  const form = useForm<ForecastByRoomTypeReportFormModel>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: defaultValues,
  });

  /*******************************  dependencies values *******************************/

  useDependenciesValues(form);

  /*******************************  dependencies values *******************************/

  return (
    <FormProvider {...form}>
      <FilterForm onSubmit={onSubmit} onReset={() => form.reset(defaultValues)} />
    </FormProvider>
  );
};
